import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters('dashboard', [
      'pages',
      'pagesChannels',
      'pagesIds',
    ]),
    ...mapState('filter', [
      'globalFilter',
    ]),
  },
};
